import React, { useState } from "react";
import { RefundP2PPayment } from "../../../pages";
import * as yup from "yup";
import { MimaToastUtil } from "../../../components";
import constant from "../../../utils/constant";
import { MoneyExController } from "../../../controllers";
import { handleImageUpload } from "../../../utils/utils";

const RefundP2PPaymentContainer = ({ closeModal, singleItem }) => {
  const [loading, setLoading] = useState(false);
  const validationSchema = () => {
    return yup.object().shape({
      sellerStatus: yup.string().required("Select Status"),
    });
  };

  const statusData = [
    { key: "PAID", value: "PAID" },
    { key: "FALSE-PAYMENT", value: "FALSE-PAYMENT" },
  ];

  const onSubmit = async (values) => {
    if (!values.files || values.files.length < 1) {
      return MimaToastUtil.error({
        message: "Kindly add at least 1 file",
      });
    }

    setLoading(true);
    let fileUrls = [];

    fileUrls = await handleImageUpload(values.files);
    if (fileUrls.length < 1 || fileUrls === constant.Failed) {
      setLoading(false);
      return MimaToastUtil.error({
        message: "file upload failed, try again",
      });
    }
    const payload = {
      amount: values.amount,
      sellerStatus: values.sellerStatus,
      moneyExOrderId: singleItem._id,
      adminBuyerPaymentProofUrls: fileUrls,
    };

    const { status, errorMessage } =
      await MoneyExController.refundP2PPayment(payload);
    if (status === constant.Success) {
      MimaToastUtil.success({ message: "Payment updated successfully" });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };
  return (
    <RefundP2PPayment
      closeModal={closeModal}
      singleItem={singleItem}
      statusData={statusData}
      onSubmit={onSubmit}
      loading={loading}
      validationSchema={validationSchema}
    />
  );
};

export default RefundP2PPaymentContainer;
